<template>
  <div ref="root" class="ur-ss" :class="{ 'is-open': open }">
    <!-- Trigger -->
    <div
      class="ur-ss-trigger"
      :class="{ 'is-open': open }"
      tabindex="0"
      @click="toggle"
      @keydown.esc="open = false"
    >
      <span class="ur-ss-value" :class="{ 'is-ph': !selectedLabel }">
        {{ selectedLabel || placeholder }}
      </span>
      <span class="ur-ss-arrow" :class="{ 'is-open': open }">▼</span>
    </div>

    <!-- Menu -->
    <div v-if="open" class="ur-ss-menu">
      <!-- Search row -->
      <div class="ur-ss-search">
        <svg class="ur-ss-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke="#999" stroke-width="2" />
          <path d="M16.5 16.5L21 21" stroke="#999" stroke-width="2" stroke-linecap="round" />
        </svg>
        <input
          ref="search"
          v-model="search"
          class="ur-ss-search-input"
          :placeholder="$t('URBANRENEWAL_ADMIN.SIM.SEARCH_PH')"
          @mousedown.stop
          @click.stop
        />
      </div>

      <!-- Options -->
      <div class="ur-ss-list">
        <div v-if="!filtered.length" class="ur-ss-empty">
          {{ $t('URBANRENEWAL_ADMIN.SIM.NO_RESULT') }}
        </div>
        <div
          v-for="opt in filtered"
          :key="opt.value"
          class="ur-ss-option"
          :class="{ 'is-sel': opt.value === value }"
          @click="select(opt)"
        >{{ opt.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UrbanRenewalSearchSelect',

  props: {
    value: { type: [String, Number], default: null },
    options: { type: Array, default: function() { return []; } },
    placeholder: { type: String, default: '' },
  },

  data() {
    return {
      open: false,
      search: '',
    };
  },

  computed: {
    selectedLabel() {
      var self = this;
      var found = this.options.find(function(o) { return o.value === self.value; });
      return found ? found.label : '';
    },

    filtered() {
      var q = this.search.trim().toLowerCase();
      if (!q) return this.options;
      return this.options.filter(function(o) {
        return String(o.label).toLowerCase().indexOf(q) !== -1;
      });
    },
  },

  watch: {
    open(v) {
      if (v) {
        var self = this;
        this.$nextTick(function() {
          if (self.$refs.search) self.$refs.search.focus();
        });
      } else {
        this.search = '';
      }
    },
  },

  mounted() {
    document.addEventListener('mousedown', this.onDocMouseDown);
  },

  beforeDestroy() {
    document.removeEventListener('mousedown', this.onDocMouseDown);
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },

    select(opt) {
      this.$emit('input', opt.value);
      this.open = false;
    },

    onDocMouseDown(e) {
      if (this.open && this.$refs.root && !this.$refs.root.contains(e.target)) {
        this.open = false;
      }
    },
  },
};
</script>
